var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg64(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9492 9.375L36.9141 12.4609L7.85156 27.2656C7.75391 26.5234 7.69531 25.7617 7.69531 25C7.71484 15.4297 15.4687 7.69531 25.0391 7.69531C27.9883 7.69531 30.8789 8.45703 33.457 9.90234L36.8945 8.14453L37.4023 7.89063C27.9688 1.01563 14.7461 3.125 7.87109 12.5781C5.25594 16.1921 3.84794 20.5391 3.84766 25C3.84766 25.5469 3.86719 26.0742 3.90625 26.6016C4.02344 28.1445 3.20312 29.6094 1.81641 30.3125L0 31.2695V35.5859L5.35156 32.8516L7.08984 31.9727L8.78906 31.0938L39.4336 15.4688L42.8711 13.7109L50 10.0977V5.78125L42.9492 9.375ZM50 14.4336L10.5273 34.5313L7.08984 36.2891L0 39.9023V44.2188L7.03125 40.625L13.0469 37.5586L42.1484 22.7344C42.2461 23.4961 42.3047 24.2578 42.3047 25.0195C42.3047 34.5898 34.5312 42.3242 24.9805 42.3242C22.0117 42.3242 19.1016 41.5625 16.5234 40.1172L16.3086 40.2344L12.5781 42.1289C22.0312 48.9844 35.2539 46.8945 42.1289 37.4414C44.7461 33.8281 46.1719 29.4922 46.1719 25.0195C46.1719 24.4727 46.1523 23.9258 46.1133 23.3984C45.9961 21.8555 46.8164 20.3906 48.2031 19.6875L50.0195 18.7695V14.4336H50Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg64);
export default __webpack_public_path__ + "static/media/64.87806f69286a555d44b099a95f91ea36.svg";
export { ForwardRef as ReactComponent };